module.exports = __webpack_public_path__ + "images/videoCaseStudy-mandel-whyus-photo-03.jpg?h=5ec0a521e98b4cdb55a361d08fcaca41";


//////////////////
// WEBPACK FOOTER
// ./src/theme/images/videoCaseStudies/mandel/videoCaseStudy-mandel-whyus-photo-03.jpg
// module id = 2110
// module chunks = 12 15